import { PropertySetModule } from '@/services/admin/property-set/modal'
import { CaseModal } from '@/services/project/cases.service'
import { SimulationModal, getSimPropertyType, initSimulation, setPropertySetsToSim } from '@/services/project/simulation.service'
import { Button, Checkbox, Form, List, Modal, ModalProps, Row, Space, Typography } from 'antd'
import { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import styles from './styles.module.less';
import classNames from 'classnames'
import { ExperimentOutlined } from '@ant-design/icons'

interface ConfigSimulationModalProps extends ModalProps {
  onSuccess?: () => void
  projectCase?: CaseModal
  cases: CaseModal[]
  simulations: SimulationModal[]
  propertySets: PropertySetModule.Modal[]
  fsId: number
}

function ConfigSimulationModal(props: ConfigSimulationModalProps) {
  const [visible, setVisible] = useState(true)
  const {propertySets, cases, simulations, onCancel, onSuccess, fsId} = props
  const [selected, setSelected] = useState(cases[0])
  const [form] = Form.useForm()

  const selectedSim = simulations.find(item => item.opcase.id === selected?.id)

  const options = propertySets.map(item => {
    return {label: item.name, value: item.name}
  })

  useEffect(() => {
    if (selectedSim) {
      getSimPropertyType({sId: selectedSim.id}).then((simSets) => {
        form.setFieldsValue({tpps: simSets.map(item => item.name)})
      })
    }
  }, [selectedSim])

  const handleCancel = (e) => {
    setVisible(false)
    onCancel?.(e)
  }

  const onChange = () => {}

  const onSubmit = async (values) => {
    const sim = await initSimulation({fsId, caseId: selected.id})
    await setPropertySetsToSim(values, {sId: sim.id})
    onSuccess?.()
  }

  useEffect(() => {
  }, [])

  return (
    <Modal
      {...props}
      width={800}
      maskClosable={false}
      open={visible}
      footer={null}
    >
      <h3>Config Simulations</h3>
      <div style={{height: 300}} className={styles.configContainer}>
        <div style={{width: 300}}>
           <List
            header={<div>Simulations</div>}
            bordered
            dataSource={cases}
            renderItem={(item) => {
              const valid = simulations.some(sim => sim.opcase.id === item.id);
              const active = selected === item;
              return <List.Item
                className={active ? 'selected' : ''}
                style={{cursor: 'pointer'}} onClick={() => {
                if (active) return;
                form.resetFields()
                setSelected(item)
              }}>
                <ExperimentOutlined className={classNames(styles.simIcon, !valid && styles.error)} /> {item.number} - {item.name}
              </List.Item>
            }}
          />

        </div>
        <div className='ml-2'>
          <div><Typography.Text>Name:</Typography.Text><span>{selected.number} - {selected.name}</span> </div>
          <Form
            form={form}
            className='mt-3'
            layout='vertical'
            onFinish={onSubmit}
          >
            <Form.Item label='Property Sets' name='tpps' rules={[{ required: true, message: 'Please enter case number' }]}>
              <Checkbox.Group options={options} onChange={onChange} />
            </Form.Item>

            <Row justify={'end'} className='mt-4'>
              <Space>
                <Button htmlType="button" onClick={handleCancel}>Cancel</Button>
                <Button type="primary" htmlType="submit">{selectedSim ? 'Submit' : 'Initialize'}</Button>
              </Space>
            </Row>
          </Form>
        </div>
      </div>
    </Modal>
  )
}

ConfigSimulationModal.show = (props: ConfigSimulationModalProps) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const clean = () => {
    ReactDOM.unmountComponentAtNode(div)
    div.remove()
  }

  ReactDOM.render(
    <ConfigSimulationModal
      {...props}
      onCancel={(e) => {
        props.onCancel?.(e)
        clean()
      }}
      onSuccess={() => {
        props.onSuccess?.()
        clean()
      }}
    />,
    div
  )
}

export default ConfigSimulationModal
